import { TourProvider as TourContextProvider } from '../contexts/TourContext';
import { TourRenderer } from './TourRenderer';

/**
 * Root wrapper — renders context provider + renderer.
 * Place inside BrowserRouter so tours can use routing.
 */
export function TourProvider({ children }: { children: React.ReactNode }) {
  return (
    <TourContextProvider>
      {children}
      <TourRenderer />
    </TourContextProvider>
  );
}
